module.exports = __webpack_public_path__ + "static/img/4.bef29d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/4.png
// module id = 37C2
// module chunks = 0